export default "__VITE_ASSET__CxmfhGZP__"